import React, { Component } from "react";
import Button from "../Button/Button";
import { voteLimit } from "../../config";
import './VotingBanner.css';

class VotingBanner extends Component {
  render() {
    return (
      <div className="voting-banner">
        <div className="copy">
          <h3>
            {this.props.count}/{voteLimit} Videos Chosen
          </h3>
          <p>You can choose up to {voteLimit} videos</p>
        </div>
        <div className="action">
          <Button onClick={this.props.submitVotes}>Submit Your Votes</Button>
        </div>
      </div>
    );
  }
}

export default VotingBanner;



// WEBPACK FOOTER //
// ./src/components/VotingBanner/VotingBanner.js